import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Controller } from "react-hook-form";

const SearchDropdown = ({
  options,
  name,
  label,
  control,
  error,
  helperText,
  required,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={""}
      render={({ field, fieldState: { error, invalid } }) => (
        <Autocomplete
          disableClearable
          options={options}
          {...field}
          size="small"
          onChange={(event, value) =>
            value.label && field.onChange(value.label)
          }
          renderInput={(params) => (
            <TextField
              required={required}
              id={name}
              margin="dense"
              size={"small"}
              fullWidth
              label={label}
              helperText={error ? error.message : helperText}
              {...params}
              error={invalid}
            />
          )}
          {...props}
        />
      )}
    />
  );
};

export default SearchDropdown;
